<template>
    <SocialsList v-if="!showDetails" @edit="editSocial($event)" />
    <SocialDetails
        v-else
        :social="socialToEdit"
        :backupData="backupData"
        @cancel="cancelSocial"
        @save="saveSocial"
    />
</template>

<script>
import { cloneDeep } from "@/shared/utils/helpers.js";
import { mapState, mapActions } from "vuex";
import SocialsList from "./socials/SocialsList.vue";
import SocialDetails from "./socials/SocialDetails.vue";

export default {
    components: {
        SocialsList,
        SocialDetails,
    },
    data() {
        return {
            showDetails: false,
            socialToEdit: {},
            backupData: {},
        };
    },
    computed: {
        ...mapState("legal", ["footer"]),
    },
    methods: {
        ...mapActions("legal/projects", ["saveSnapshot", "loadProject"]),
        editSocial(social) {
            this.socialToEdit = social;
            this.backupData = cloneDeep(this.socialToEdit);
            this.showDetails = true;
        },
        async saveSocial() {
            await this.saveSnapshot();
            this.showDetails = false;
        },
        async cancelSocial() {
            await this.loadProject(this.footer.uuid);
            this.showDetails = false;
        },
    },
};
</script>
